var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { URL_API } from '../../../../api';
import { getTokenFromCookie } from '../../../../services/mt_login';
import { ModalConfirmarAprovar, ModalConfirmarReprovar } from './index';
import { getJustificativaAnalise, getJustificativaDetalhes, patchAprovarJustificativa, patchReprovarJustificativa } from '../tratamento_justificativas_service';
import { ModalJustificativaConteudo } from './modal_justificativa_conteudo';
export function ModalJustificativa(_a) {
    var _this = this;
    var open = _a.open, onClose = _a.onClose, onSuccess = _a.onSuccess, justificativaId = _a.justificativaId, modo = _a.modo;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var isAnalisar = modo === 'analisar';
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), loadingDownloadId = _c[0], setLoadingDownloadId = _c[1];
    var _d = useState(false), submitting = _d[0], setSubmitting = _d[1];
    var _e = useState(null), dados = _e[0], setDados = _e[1];
    // Estados exclusivos do modo analisar
    var _f = useState(''), observacao = _f[0], setObservacao = _f[1];
    var _g = useState(false), observacaoError = _g[0], setObservacaoError = _g[1];
    var _h = useState(false), confirmarAprovarOpen = _h[0], setConfirmarAprovarOpen = _h[1];
    var _j = useState(false), confirmarReprovarOpen = _j[0], setConfirmarReprovarOpen = _j[1];
    useEffect(function () {
        if (open && justificativaId) {
            if (isAnalisar) {
                setObservacao('');
                setObservacaoError(false);
                setConfirmarAprovarOpen(false);
                setConfirmarReprovarOpen(false);
            }
            carregarDados(justificativaId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, justificativaId]);
    var carregarDados = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var resp, _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    if (!isAnalisar) return [3 /*break*/, 3];
                    return [4 /*yield*/, getJustificativaAnalise(id)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, getJustificativaDetalhes(id)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    resp = _a;
                    if (resp.Status === 'OK')
                        setDados(resp.dados);
                    return [3 /*break*/, 8];
                case 6:
                    error_1 = _b.sent();
                    console.error('Erro ao carregar dados da justificativa:', error_1);
                    enqueueSnackbar('Erro ao carregar os dados da justificativa.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    return [3 /*break*/, 8];
                case 7:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var validarObservacao = function () {
        if (!observacao.trim()) {
            setObservacaoError(true);
            enqueueSnackbar('A observação é obrigatória.', { variant: 'warning', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            return false;
        }
        return true;
    };
    var handleAprovar = function () {
        if (!validarObservacao() || !dados)
            return;
        setConfirmarAprovarOpen(true);
    };
    var handleReprovar = function () {
        if (!validarObservacao() || !dados)
            return;
        setConfirmarReprovarOpen(true);
    };
    var handleConfirmarAprovar = function () { return __awaiter(_this, void 0, void 0, function () {
        var resp, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dados)
                        return [2 /*return*/];
                    setSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, patchAprovarJustificativa(dados.id, observacao)];
                case 2:
                    resp = _a.sent();
                    if (resp.Status === 'OK') {
                        setConfirmarAprovarOpen(false);
                        enqueueSnackbar('Justificativa aprovada com sucesso.', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        onClose();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    enqueueSnackbar('Erro ao aprovar a justificativa. Tente novamente.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    return [3 /*break*/, 5];
                case 4:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleConfirmarReprovar = function () { return __awaiter(_this, void 0, void 0, function () {
        var resp, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dados)
                        return [2 /*return*/];
                    setSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, patchReprovarJustificativa(dados.id, observacao)];
                case 2:
                    resp = _a.sent();
                    if (resp.Status === 'OK') {
                        setConfirmarReprovarOpen(false);
                        enqueueSnackbar('Justificativa reprovada com sucesso.', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        onClose();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    enqueueSnackbar('Erro ao reprovar a justificativa. Tente novamente.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    return [3 /*break*/, 5];
                case 4:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleVisualizarArquivo = function (url, anexoId) { return __awaiter(_this, void 0, void 0, function () {
        var token, fullUrl, response, blob, blobUrl, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    setLoadingDownloadId(anexoId);
                    token = getTokenFromCookie();
                    fullUrl = url.startsWith('http') ? url : "".concat(URL_API).concat(url.replace(/^\\/, ''), "?source=web");
                    return [4 /*yield*/, fetch(fullUrl, {
                            method: 'GET',
                            headers: { Authorization: "Bearer ".concat(token) },
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _a.sent();
                    blobUrl = window.URL.createObjectURL(blob);
                    window.open(blobUrl, '_blank');
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_4 = _a.sent();
                    console.error('Erro ao visualizar arquivo:', error_4);
                    return [3 /*break*/, 6];
                case 5:
                    setLoadingDownloadId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var formatarDataHora = function (iso) {
        if (!iso)
            return 'N/A';
        var date = new Date(iso);
        var d = String(date.getDate()).padStart(2, '0');
        var m = String(date.getMonth() + 1).padStart(2, '0');
        var y = date.getFullYear();
        var h = String(date.getHours()).padStart(2, '0');
        var min = String(date.getMinutes()).padStart(2, '0');
        return "".concat(d, "/").concat(m, "/").concat(y, " \u00E0s ").concat(h, ":").concat(min);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Dialog, __assign({ open: open, onClose: onClose, fullWidth: true, maxWidth: 'sm', PaperProps: { sx: { borderRadius: 3, overflow: 'hidden' } } }, { children: [_jsxs(DialogTitle, __assign({ sx: {
                            p: 2,
                            px: 2.5,
                            display: isAnalisar ? 'flex' : 'none',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #E5E7EB',
                            backgroundColor: '#F9FAFB',
                        } }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', sx: { fontWeight: 800, color: '#111827' } }, { children: "Analisar Justificativa" })), _jsx(IconButton, __assign({ onClick: onClose, size: 'small', disabled: submitting, sx: { color: '#6B7280', '&:hover': { backgroundColor: '#F3F4F6' } } }, { children: _jsx(CloseIcon, { fontSize: 'small' }) }))] })), _jsx(DialogContent, __assign({ sx: { p: 0 } }, { children: _jsx(ModalJustificativaConteudo, __assign({ loading: loading, dados: dados, loadingDownloadId: loadingDownloadId, onVisualizarArquivo: handleVisualizarArquivo, formatarDataHora: formatarDataHora, modo: modo }, { children: isAnalisar && (_jsxs(Box, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5 } }, { children: [_jsx(Typography, __assign({ variant: 'caption', sx: { color: '#6B7280', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' } }, { children: "OBSERVA\u00C7\u00C3O (OBRIGAT\u00D3RIO)*" })), _jsxs(Typography, __assign({ variant: 'caption', sx: { color: observacao.length >= 200 ? '#EF4444' : '#9CA3AF', fontWeight: 500 } }, { children: [observacao.length, "/200"] }))] })), _jsx(TextField, { fullWidth: true, multiline: true, rows: 3, placeholder: 'Escreva a justificativa para sua aprova\u00E7\u00E3o ou recusa...', value: observacao, onChange: function (e) {
                                            setObservacao(e.target.value.substring(0, 200));
                                            if (observacaoError && e.target.value.trim())
                                                setObservacaoError(false);
                                        }, error: observacaoError, helperText: observacaoError ? 'A observação é obrigatória para processar esta justificativa.' : undefined, disabled: submitting, sx: {
                                            '& .MuiOutlinedInput-root': {
                                                fontSize: '0.875rem',
                                                '&.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: '#EF4444', borderWidth: 2 },
                                            },
                                            '& .MuiFormHelperText-root.Mui-error': { color: '#EF4444', fontWeight: 600 },
                                        } })] })) })) })), _jsx(DialogActions, __assign({ sx: {
                            p: 2,
                            px: 2.5,
                            borderTop: '1px solid #E5E7EB',
                            backgroundColor: '#F9FAFB',
                            justifyContent: isAnalisar ? 'space-between' : 'center',
                            gap: 1.5,
                        } }, { children: isAnalisar ? (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ variant: 'outlined', onClick: handleReprovar, disabled: submitting || loading || !dados, sx: {
                                        fontWeight: 700,
                                        color: '#B91C1C',
                                        borderColor: '#FECACA',
                                        backgroundColor: '#FFF5F5',
                                        '&:hover': { backgroundColor: '#FEE2E2', borderColor: '#FCA5A5' },
                                        '&:disabled': { opacity: 0.5 },
                                    } }, { children: "REPROVAR" })), _jsx(Button, __assign({ variant: 'contained', onClick: handleAprovar, disabled: submitting || loading || !dados, disableElevation: true, sx: {
                                        fontWeight: 700,
                                        backgroundColor: '#16A34A',
                                        color: '#fff',
                                        '&:hover': { backgroundColor: '#15803D' },
                                        '&:disabled': { opacity: 0.5 },
                                    } }, { children: "APROVAR" }))] })) : (_jsx(Button, __assign({ fullWidth: true, variant: 'outlined', onClick: onClose, sx: {
                                py: 1,
                                borderRadius: 2,
                                fontWeight: 700,
                                color: '#4B5563',
                                borderColor: '#D1D5DB',
                                backgroundColor: '#FFFFFF',
                                '&:hover': { backgroundColor: '#F3F4F6', borderColor: '#D1D5DB' },
                            } }, { children: "FECHAR JANELA" }))) }))] })), isAnalisar && (_jsxs(_Fragment, { children: [_jsx(ModalConfirmarAprovar, { open: confirmarAprovarOpen, onCancel: function () { return setConfirmarAprovarOpen(false); }, onConfirm: handleConfirmarAprovar, submitting: submitting }), _jsx(ModalConfirmarReprovar, { open: confirmarReprovarOpen, onCancel: function () { return setConfirmarReprovarOpen(false); }, onConfirm: handleConfirmarReprovar, submitting: submitting })] }))] }));
}
